const axios = require("axios");
const VueCookies = require("vue-cookies");
const store = require("../store/index");
const { getCookie, getCookieByName, getApiURL } = require("./functions");
const { isVentaAsistida } = require("./salesChannel");

// Identificador unico por evento. Si el pixel del navegador reporta el mismo hecho, tiene
// que mandar este mismo valor: es lo unico que le permite a Meta contar una sola conversion.
const buildEventId = Event => `${Event}.${Date.now()}.${Math.random().toString(36).slice(2, 10)}`;

// _fbc es el comprobante del clic en el anuncio y lo que permite atribuir la venta a la
// campana. La cookie la crea el pixel del navegador, pero cuando el usuario recien llega
// desde un anuncio todavia no existe, asi que se arma con el fbclid de la URL.
// El fbclid solo viaja en la URL de la primera pantalla y se pierde en la primera
// recarga, mucho antes del Purchase. Se guarda apenas se lo ve, con el _fbc ya armado:
// el timestamp tiene que ser el del clic en el anuncio, no el del evento.
const FBC_COOKIE = "urg_fbc";

// Misma vida que la _fbc del pixel de Meta.
const FBC_COOKIE_DAYS = "90d";

// El primer numero del _fbc/_fbp es el "subdomain index": depende de sobre que dominio
// escribio la cookie el pixel. Se lo copiamos al _fbp que el pixel ya dejo, en vez de
// hardcodear un valor que no vale para todos los dominios.
const getSubdomainIndex = () =>
{
    const Fbp = getCookieByName("_fbp");
    const Partes = Fbp ? String(Fbp).split(".") : [];

    return Partes.length >= 2 && /^\d+$/.test(Partes[1]) ? Partes[1] : "2";
}

const readFbclid = () =>
{
    try
    {
        return new URLSearchParams(window.location.search).get("fbclid");
    }
    catch(error)
    {
        return null;
    }
}

// Se llama desde el router en cada navegacion: la primera es la que trae el fbclid.
const captureFbc = () =>
{
    // La cookie que escribe el pixel del navegador manda: es la fuente original.
    if (getCookieByName("_fbc")) return;

    const Fbclid = readFbclid();
    if (!Fbclid) return;

    const Guardada = getCookieByName(FBC_COOKIE);
    if (Guardada && Guardada.endsWith(`.${Fbclid}`)) return;

    VueCookies.set(FBC_COOKIE, `fb.${getSubdomainIndex()}.${Date.now()}.${Fbclid}`, FBC_COOKIE_DAYS);
}

const getFbc = () =>
{
    const Cookie = getCookieByName("_fbc");
    if (Cookie) return Cookie;

    const Fbclid = readFbclid();
    if (Fbclid) return `fb.${getSubdomainIndex()}.${Date.now()}.${Fbclid}`;

    return getCookieByName(FBC_COOKIE) || undefined;
}

// Ciudad, provincia y codigo postal salen de la zona elegida en el formulario. Se arman
// aca para no repetir el mapeo en cada flujo y para no volver a mandar el objeto entero.
const LocationFields = Direccion =>
{
    const Localidad = Direccion && Direccion.Localidad;
    if (!Localidad) return {};

    var Zip = Localidad.cp;

    if (!Zip && Localidad.postal_codes)
    {
        try
        {
            const Codes = typeof Localidad.postal_codes === "string"
                ? JSON.parse(Localidad.postal_codes)
                : Localidad.postal_codes;

            if (Array.isArray(Codes)) Zip = Codes[0];
        }
        catch(error)
        {
            Zip = undefined;
        }
    }

    return { city: Localidad.title, state: Localidad.province, zip: Zip };
}

const Pixel = async InitPayload =>
{
    try
    {
        // Las ventas asistidas por promotor no son conversiones del anuncio. No sale ningun
        // evento ni ningun dato de la persona.
        if (isVentaAsistida(store.default)) return;

        var Payload = structuredClone(InitPayload);
        Payload.url = window.location.href;
        Payload.user_agent = navigator.userAgent;

        // En la compra el event_id es el nro de socio: es el mismo ID de transaccion que
        // recibe GA4, asi cada Purchase de Meta se cruza uno a uno con una venta de GA4, y
        // si la misma compra se llegara a enviar dos veces Meta la descarta como duplicada.
        Payload.event_id = Payload.event === "Purchase" && Payload.subscription_id
            ? String(Payload.subscription_id)
            : buildEventId(Payload.event);
        Payload.fbc = getFbc();
        Payload.fbp = getCookieByName("_fbp");

        // Nro de afiliado cuando ya existe; en los pasos previos del embudo alcanza con el
        // token de sesion para que Meta pueda unir los eventos de la misma persona.
        if (!Payload.external_id) Payload.external_id = Payload.subscription_id || getCookie();

        // Queda publicado para que el tag de Meta en GTM pueda reusar el mismo event_id y
        // los dos envios se dedupliquen entre si.
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "meta_capi",
            meta_event_name: Payload.event,
            meta_event_id: Payload.event_id
        });

        const baseURL = getApiURL();

        await axios.post(`${baseURL}/pxfb/`, Payload);
    }
    catch(error)
    {
        console.log(error);
    }
}

module.exports = { Pixel, LocationFields, captureFbc, getFbc };
